import { render } from "./App.vue?vue&type=template&id=5c15b8bf"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5c15b8bf&lang=css"

import exportComponent from "/Users/jade/Documents/D1m/website-urlscheme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__